import { render } from "./ShippingMethods.vue?vue&type=template&id=7022a020&ts=true"
import script from "./ShippingMethods.vue?vue&type=script&lang=ts"
export * from "./ShippingMethods.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__